'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; // @file: Toolbar component jsx file
// @auth: spc@data.me 2017/10/10

// import unlinkIcon from '../../../../icon/unlink.svg';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _draftJs = require('draft-js');

var _utils = require('../../utils');

var _LinkModal = require('../LinkModal');

var _LinkModal2 = _interopRequireDefault(_LinkModal);

var _CustomModal = require('../CustomModal');

var _CustomModal2 = _interopRequireDefault(_CustomModal);

var _bold = require('../../../../icon/bold.svg');

var _bold2 = _interopRequireDefault(_bold);

var _italic = require('../../../../icon/italic.svg');

var _italic2 = _interopRequireDefault(_italic);

var _underscore = require('../../../../icon/underscore.svg');

var _underscore2 = _interopRequireDefault(_underscore);

var _title = require('../../../../icon/title.svg');

var _title2 = _interopRequireDefault(_title);

var _alignLeft = require('../../../../icon/align-left.svg');

var _alignLeft2 = _interopRequireDefault(_alignLeft);

var _alignCenter = require('../../../../icon/align-center.svg');

var _alignCenter2 = _interopRequireDefault(_alignCenter);

var _alignRight = require('../../../../icon/align-right.svg');

var _alignRight2 = _interopRequireDefault(_alignRight);

var _list = require('../../../../icon/list.svg');

var _list2 = _interopRequireDefault(_list);

var _orderedList = require('../../../../icon/ordered-list.svg');

var _orderedList2 = _interopRequireDefault(_orderedList);

var _link = require('../../../../icon/link.svg');

var _link2 = _interopRequireDefault(_link);

var _img = require('../../../../icon/img.svg');

var _img2 = _interopRequireDefault(_img);

var _clean = require('../../../../icon/clean.svg');

var _clean2 = _interopRequireDefault(_clean);

var _factube = require('../../../../icon/factube.svg');

var _factube2 = _interopRequireDefault(_factube);

require('./styles.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToolBar = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ToolBar, _Component);

    function ToolBar() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ToolBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ToolBar.__proto__ || (0, _getPrototypeOf2.default)(ToolBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showLinkModal: false,
            showCustomModal: false,
            currentTextAlignment: undefined,
            currentTextStyle: undefined,
            currentBlockType: undefined
        }, _this.onStyleChange = function (blockStyle) {
            var _this$props = _this.props,
                currentState = _this$props.currentState,
                changeState = _this$props.changeState;

            var newState = _draftJs.RichUtils.toggleInlineStyle(currentState, blockStyle);
            if (newState) {
                changeState(newState);
            }
        }, _this.onTypeChange = function (blockType) {
            var _this$props2 = _this.props,
                currentState = _this$props2.currentState,
                changeState = _this$props2.changeState;

            var newState = _draftJs.RichUtils.toggleBlockType(currentState, blockType);
            if (newState) {
                if (blockType === 'ordered-list-item' || blockType === 'unordered-list-item') {
                    changeState((0, _utils.setBlockData)(newState, { 'text-align': undefined }));
                } else {
                    changeState(newState);
                }
            }
        }, _this.onCleanClick = function () {
            var currentState = _this.props.currentState;

            var contentState = currentState.getCurrentContent();
            ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'MONOSPACE', 'FONTFAMILY', 'COLOR', 'BGCOLOR', 'FONTSIZE', 'SUPERSCRIPT', 'SUBSCRIPT'].forEach(function (style) {
                contentState = _draftJs.Modifier.removeInlineStyle(contentState, currentState.getSelection(), style);
            });
            var noStyleState = _draftJs.EditorState.push(currentState, contentState, 'change-inline-style');
            var noTypeState = _draftJs.RichUtils.toggleBlockType(noStyleState, 'unstyled');
            _this.props.changeState((0, _utils.setBlockData)(noTypeState, { 'text-align': undefined }));
        }, _this.onImgClick = function () {
            _this.imgInput.value = null;
            _this.imgInput.click();
        }, _this.onImgChange = function (event) {
            var file = event.target.files[0];
            if (file.type.indexOf('image/') === 0) {
                var src = URL.createObjectURL(file);
                var currentState = _this.props.currentState;

                var entityKey = _draftJs.Entity.create('IMAGE', 'MUTABLE', { src: src, alignment: 'center', loading: true });
                var newState = _draftJs.AtomicBlockUtils.insertAtomicBlock(currentState, entityKey, ' ');
                _this.props.changeState(newState);
                _this.props.imageUploader(file).then(function (data) {
                    var contentState = newState.getCurrentContent().replaceEntityData(entityKey, { src: data.src, alignment: 'center' });
                    var newerState = _draftJs.EditorState.push(newState, contentState, 'apply-entity');
                    _this.props.changeState(_draftJs.EditorState.forceSelection(newerState, newerState.getSelection()));
                });
            }
        }, _this.toggleAlignment = function (alignment) {
            var currentState = _this.props.currentState;
            var currentTextAlignment = _this.state.currentTextAlignment;

            if (currentTextAlignment !== alignment) {
                _this.props.changeState((0, _utils.setBlockData)(currentState, { 'text-align': alignment }));
            } else {
                _this.props.changeState((0, _utils.setBlockData)(currentState, { 'text-align': undefined }));
            }
        }, _this.showLinkModal = function () {
            _this.setState({
                showLinkModal: true
            });
        }, _this.hideLinkModal = function () {
            _this.setState({
                showLinkModal: false
            });
        }, _this.submitLink = function (linkTitle, linkTarget) {
            _this.addLink(linkTitle, linkTarget);
            _this.hideLinkModal();
        }, _this.addLink = function (linkTitle, linkTarget) {
            var currentState = _this.props.currentState;
            // const contentState = currentState.getCurrentContent();

            var entityKey = _draftJs.Entity.create('LINK', 'MUTABLE', {
                url: linkTarget
            });
            var newState = _draftJs.RichUtils.toggleLink(currentState, currentState.getSelection(), entityKey);
            var contentState = _draftJs.Modifier.replaceText(newState.getCurrentContent(), newState.getSelection(), '' + linkTitle, newState.getCurrentInlineStyle(), entityKey);
            _this.props.changeState(_draftJs.EditorState.push(newState, contentState, 'insert-characters'));
        }, _this.showCustomModal = function () {
            _this.setState({
                showCustomModal: true
            });
        }, _this.hideCustomModal = function () {
            _this.setState({
                showCustomModal: false
            });
        }, _this.submitCustom = function (customData) {
            _this.addCustom(customData);
            _this.hideCustomModal();
        }, _this.addCustom = function (customData) {
            if (customData) {
                var currentState = _this.props.currentState;

                var entityKey = _draftJs.Entity.create('CUSTOM', 'INMUTABLE', { customData: customData });
                _this.props.changeState(_draftJs.AtomicBlockUtils.insertAtomicBlock(currentState, entityKey, ' '));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ToolBar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            if (props.currentState !== this.props.currentState) {
                this.setState({
                    currentTextAlignment: (0, _utils.getCurrentBlock)(props.currentState).getData().get('text-align'),
                    currentTextStyle: props.currentState.getCurrentInlineStyle(),
                    currentBlockType: _draftJs.RichUtils.getCurrentBlockType(props.currentState)
                });
            }
        }
        // clear all style, metas, special types

        // add new image

        // upload image

        // change alignment data

        // show add link modal

        // hide add link modal

        // call on link request submitted

        // add a new link

        // show add Custom modal

        // hide add Custom modal

        // call on link request submitted

        // add a new Custom

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-toolbar' },
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('BOLD') }),
                        title: '\u52A0\u7C97',
                        onClick: function onClick() {
                            return _this2.onStyleChange('BOLD');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _bold2.default, alt: 'Bold' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('ITALIC') }),
                        title: '\u659C\u4F53',
                        onClick: function onClick() {
                            return _this2.onStyleChange('ITALIC');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _italic2.default, alt: 'Italic' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextStyle && this.state.currentTextStyle.has('UNDERLINE') }),
                        title: '\u4E0B\u5212\u7EBF',
                        onClick: function onClick() {
                            return _this2.onStyleChange('UNDERLINE');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _underscore2.default, alt: 'UNDERLINE' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'header-three' }),
                        title: '\u6807\u9898',
                        onClick: function onClick() {
                            return _this2.onTypeChange('header-three');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _title2.default, alt: 'Title' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'left' }),
                        title: '\u5DE6\u5BF9\u9F50',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('left');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignLeft2.default, alt: 'Left' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'center' }),
                        title: '\u5C45\u4E2D',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('center');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignCenter2.default, alt: 'Center' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentTextAlignment === 'right' }),
                        title: '\u53F3\u5BF9\u9F50',
                        onClick: function onClick() {
                            return _this2.toggleAlignment('right');
                        },
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _alignRight2.default, alt: 'Right' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'unordered-list-item' }),
                        title: '\u9879\u76EE\u7B26\u53F7',
                        onClick: function onClick() {
                            return _this2.onTypeChange('unordered-list-item');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _list2.default, alt: 'List' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames2.default)('rde-toolbar-button', { 'rde-toolbar-button-on': this.state.currentBlockType === 'ordered-list-item' }),
                        title: '\u5217\u8868',
                        onClick: function onClick() {
                            return _this2.onTypeChange('ordered-list-item');
                        },
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _orderedList2.default, alt: 'Order List' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: '\u63D2\u5165\u8D85\u94FE\u63A5',
                        onClick: this.showLinkModal,
                        disabled: this.state.currentBlockType === 'atomic'
                    },
                    _react2.default.createElement('img', { src: _link2.default, alt: 'Link' })
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: '\u63D2\u5165\u56FE\u7247',
                        onClick: this.onImgClick,
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _img2.default, alt: 'Insert Pic' }),
                    _react2.default.createElement('input', {
                        type: 'file',
                        accept: 'image/jpg,image/png,image/gif,image/jpeg',
                        ref: function ref(_ref2) {
                            _this2.imgInput = _ref2;
                        },
                        onChange: this.onImgChange,
                        style: { display: 'none' }
                    })
                ),
                this.props.customBlockConfig && _react2.default.createElement(
                    'button',
                    {
                        className: 'rde-toolbar-button',
                        title: this.props.customBlockConfig.customTitle,
                        onClick: this.showCustomModal,
                        disabled: this.state.currentBlockType === 'atomic' || this.state.currentBlockType === 'ordered-list-item' || this.state.currentBlockType === 'unordered-list-item'
                    },
                    _react2.default.createElement('img', { src: _factube2.default, alt: 'Insert Custom Content' })
                ),
                _react2.default.createElement(
                    'button',
                    { className: 'rde-toolbar-button', title: '\u6E05\u9664\u6837\u5F0F', disabled: this.state.currentBlockType === 'atomic', onClick: this.onCleanClick },
                    _react2.default.createElement('img', { src: _clean2.default, alt: 'Clean' })
                ),
                this.state.showLinkModal && _react2.default.createElement(_LinkModal2.default, {
                    currentState: this.props.currentState,
                    onCancel: this.hideLinkModal,
                    onSubmit: this.submitLink
                }),
                this.props.customBlockConfig && this.state.showCustomModal && _react2.default.createElement(_CustomModal2.default, {
                    customBlockConfig: this.props.customBlockConfig,
                    onCancel: this.hideCustomModal,
                    onSubmit: this.submitCustom
                })
            );
        }
    }]);
    return ToolBar;
}(_react.Component), _class.propTypes = {
    currentState: _propTypes2.default.object.isRequired,
    changeState: _propTypes2.default.func.isRequired,
    imageUploader: _propTypes2.default.func.isRequired,
    customBlockConfig: _propTypes2.default.object
}, _temp2);
exports.default = ToolBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/components/ToolBar/index.js
// module id = 108
// module chunks = 0